import { Injectable } from '@angular/core';
import { IncidentServiceBase } from '../services/incident-base.service';
import { FinanceIncident } from '../models/finance-incident.model';

@Injectable()
export class FinanceService extends IncidentServiceBase<FinanceIncident> {
    constructor() {
        super('Finance', () => new FinanceIncident());
    }
}
